// common
export const FETCH_BUNDLES_FOR_LOG = "fetchBundlesForLog";
export const SET_SNACK = "setSnack";
export const RESTORE_LOCAL_STORAGE_DATA = "restoreLocalStorageData";

// user module
export const USER_AUTH = "userAuth";
export const FETCH_COMPANY_USERS = "fetchCompanyUsers";

// species module
export const FETCH_ALL_SPECIES = "fetchAllSpecies";
export const FETCH_SPECIES = "fetchSpecies";
export const FETCH_SPECIES_FILTERS = "fetchSpeciesFilters";

// search module
export const SEARCH_LOGS = "searchLogs";
export const GET_FILTER_DATA = "getFilterData";
export const CREATE_WATCHLIST_FROM_SEARCH_PARAMS = "createWatchlistFromSearchParams";

// watchlist module
export const FETCH_WATCHLISTS = "fetchWatchlists";
export const SEARCH_WATCHLISTS = "searchWatchlists";
export const FETCH_WATCHLIST = "fetchWatchlist";
export const FETCH_WATCHLIST_ITEM = "fetchWatchlistItem";
export const CREATE_WATCHLIST = "createWatchlist";
export const ADD_TO_WATCHLIST = "addToWatchlist";
export const ADD_ALL_TO_WATCHLIST = "addAllToWatchlist";
export const REMOVE_FROM_WATCHLIST = "removeFromWatchlist";
export const DELETE_WATCHLIST = "deleteWatchlist";
export const UPDATE_WATCHLIST = "updateWatchlist";
export const UPDATE_WATCHLIST_ITEM = "updateWatchlistItem";
export const DOWNLOAD_WATCHLIST_SUMMARY = "downloadWatchlistSummary";
export const FETCH_WATCHLISTS_WITH_ITEM = "fetchWatchlistsWithItem";
export const FETCH_WATCHLIST_BY_ITEM = "fetchWatchlistByItem";

// log module
export const FETCH_LOG = "fetchLog";
export const FETCH_BUNDLES = "fetchBundles";
export const DOWNLOAD_MEASUREMENTLIST = "downloadMeasurementList";
export const DOWNLOAD_MANUAL_IMAGES = "downloadManualImages";

// pallet module
export const FETCH_LOGS_BY_PALLET_IDENTIFIERS = "fetchLogsByPalletIdentifiers";

// virtual log module
export const FETCH_VIRTUAL_LOG = "fetchVirtualLog";
export const LOAD_LOG_FOR_VIRTUAL_LOG = "loadLogForVirtualLog";
export const UPDATE_VIRTUAL_LOG = "updateVirtualLog";
export const DELETE_VIRTUAL_LOG = "deleteVirtualLog";
export const FETCH_BUNDLES_FOR_VIRTUAL_LOG = "fetchBundlesForVirtualLog";

// zoho module
export const SEARCH_ZOHO_CUSTOMERS = "searchZohoCustomers";